// eslint-disable-next-line no-shadow
export enum Typo {
  HeadingS = 'headingS',
  TextL = 'textL',
  TextXS = 'textXS',
  TextS = 'textS',
}
